const firebaseConfig = {
  apiKey: "AIzaSyDzvqJYFR7lBHOEKBKkGUGF76h1JTzWI6c",
  authDomain: "centennial-woods-28d9c.firebaseapp.com",
  projectId: "centennial-woods-28d9c",
  storageBucket: "centennial-woods-28d9c.appspot.com",
  messagingSenderId: "525253768100",
  appId: "1:525253768100:web:62e043d3d65c37abbf8731",
};
firebase.initializeApp(firebaseConfig);
firebase.analytics();

function getInputsByValue(value) {
  var allInputs = document.querySelectorAll(
    ".c-contact-form__radiobuttons-container input"
  );
  for (var x = 0; x < allInputs.length; x++) {
    if (allInputs[x].value == value) {
      allInputs[x].click();
    }
  }
}

if (window.location.hash == "#s-form-quest") {
  getInputsByValue("I Need Samples");
}

document.addEventListener("DOMContentLoaded", function () {
  var imageFiles = [];
  var sliderAdded = false;
  let swiperScroll;

  var headerSamplesBtn = document.querySelectorAll(".s-mega-menu__nav a");
  for (var i = 0; i < headerSamplesBtn.length; i++) {
    var currentAttr = headerSamplesBtn[i].getAttribute("href");
    if (currentAttr.includes("#s-form-quest")) {
      headerSamplesBtn[i].addEventListener("click", function () {
        getInputsByValue("I Need Samples");
      });
    }
  }

  //CN - wait for valid form submission before uploading images to firebase
  $("#btn-submit").on("click", function () {
    var name = $("#FormQuest-name").val();
    var email = $("#FormQuest-email").val();
    var location = $("#FormQuest-location").val();

    var re = /\S+@\S+\.\S+/;
    var validEmail = re.test(email);
    var fileCount = $("#FormQuest-file")[0].files.length;

    if (name != "" && email != "" && location != "" && validEmail) {
      if (fileCount > 0) {
        wrapperFunc(name, email, location).then((result) => {
          $("#FormQuest").submit();
        });
      } else {
        $("#FormQuest").submit();
      }
    }
  });

  //CN - add local image previews for files to be uploaded
  $("#FormQuest-file").on("change", function (e) {
    $("#FormQuest-file").each(function (index, field) {
      for (var i = 0; i < field.files.length; i++) {
        addImage(field.files[i]);
      }
    });
  });
  //CN - wrapper function to wait until uploads are processed before submitting the form
  async function wrapperFunc(name, email, location) {
    await processFiles();
  }
  //CN - process the image upload to firebase for each image
  async function processFiles(name, email, location) {
    return new Promise((resolve, _reject) => {
      $("#FormQuest-file").each(async function (index, field) {
        for (var i = 0; i < field.files.length; i++) {
          await uploadFile(i, field.files[i], name, email, location);
        }
        resolve("Completed");
      });
    });
  }

  //CN - Mod to accept name,email,location and upload as custom metadata to firebase
  function uploadFile(index, file, name, email, location) {
    return new Promise((resolve, _reject) => {
      $(".s-upload__label").text("Load file");
      $(".s-upload__button").addClass("s-upload__button_loading");
      var storageRef = firebase.storage().ref(file.name.replaceAll(" ", "_"));

      const metadata = {
        customMetadata: {
          name: name,
          email: email,
          location: location,
        },
      };

      var uploadTask = storageRef.put(file, metadata);

      uploadTask.on(
        "state_changed",
        function (snapshot) {},
        function (error) {
          console.log(error);
        },
        function () {
          uploadTask.snapshot.ref
            .getDownloadURL()
            .then(async function (downloadURL) {
              imageFiles.push(downloadURL);
              $("#FormQuest-files").val("'" + imageFiles.join("' '") + "'");
              resolve("Completed");
            });
        }
      );
    });
  }

  function addImage(file) {
    var downloadURL = URL.createObjectURL(file);
    var fileName = file.name.replaceAll(" ", "_").split(".")[0];
    if (downloadURL.includes("mp4")) {
      $(
        '<div class="s-upload__files__file swiper-slide" data-file-name="' +
          file.name.replaceAll(" ", "_") +
          '">' +
          '<div class="s-upload__files__remove js-file-remove_' +
          fileName +
          '"></div>' +
          '<video class="s-upload__files__image" width="75" height="90">' +
          '<source src="' +
          downloadURL +
          '" type="video/mp4">' +
          "</video>" +
          "</div>"
      ).insertBefore($(".s-upload__button")[0]);
    } else {
      $(
        '<div class="s-upload__files__file swiper-slide" data-file-name="' +
          file.name.replaceAll(" ", "_") +
          '">' +
          '<div class="s-upload__files__remove js-file-remove_' +
          fileName +
          '"></div>' +
          '<img class="s-upload__files__image" src="' +
          downloadURL +
          '">' +
          "</div>"
      ).insertBefore($(".s-upload__button")[0]);
    }
    $(".js-file-remove_" + fileName).on("click", function () {
      removeImage(file.name.replaceAll(" ", "_"));
    });
    if ($(".s-upload__files__file").length === 1) {
      $(".s-upload__files").addClass("s-upload__files_success");
      $(".s-upload__message").show();
    }

    $(".s-upload__label").text("Add file");
    $(".s-upload__button").removeClass("s-upload__button_loading");

    if (!sliderAdded && $(".swiper-slide").length > 3) {
      swiperScroll = new Swiper("[data-swiper-submit]", {
        slidesPerView: "auto",
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        freeMode: {
          enabled: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          300: {
            spaceBetween: 11,
          },
          768: {
            spaceBetween: 11,
          },
          1200: {
            spaceBetween: 11,
          },
        },
      });
      sliderAdded = true;
    } else if (sliderAdded && $(".s-upload__files__file").length > 1) {
      swiperScroll.update();
    }
  }

  function removeImage(file) {
    $('[data-file-name="' + file + '"]').remove();
    if ($(".s-upload__files__file").length === 0) {
      $(".s-upload__files").removeClass("s-upload__files_success");
      $(".s-upload__message").hide();
    }
  }
});
